module.exports = __webpack_public_path__ + "img/16.1c77125a.png";